import { stringToArray } from '@core/utils/string-to-array'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const CompareDocumentsSearchSchema = z.object({
  criticality: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .transform((val: string | string[] | undefined) => {
      if (!val) return undefined
      if (Array.isArray(val)) return val
      return stringToArray(val)
    }),
})

export type CompareDocumentsSearch = z.infer<
  typeof CompareDocumentsSearchSchema
>

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/compare-documents/$comparisonId/'
)({
  validateSearch: (raw) => CompareDocumentsSearchSchema.parse(raw),
})
